import SignatureManager from "./SignatureManager";
import { THEMES } from "../../config/constants";

export default function SettingsPage({ theme, staffSigs, sigSaving, saveSig, clearSig }) {
  const t = THEMES[theme];
  return (
    <div style={{maxWidth:680,margin:"0 auto"}}>
      <div style={{fontSize:20,fontWeight:700,color:t.text,marginBottom:4}}>Settings</div>
      <div style={{fontSize:13,color:t.textMuted,marginBottom:24}}>Manage staff signatures and app configuration.</div>
      <SignatureManager theme={theme} staffSigs={staffSigs} onSave={saveSig} onClear={clearSig} saving={sigSaving}/>
    </div>
  );
}

